import { render } from "./Loading-Spinner.vue?vue&type=template&id=4df24815"
import script from "./Loading-Spinner.vue?vue&type=script&lang=js"
export * from "./Loading-Spinner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__